export const mockData = {
  services: [
    {
      icon: 'automation',
      title: 'Business Operation Automation with AI',
      description: 'Streamline repetitive tasks, optimize workflows, and reduce operational costs by implementing intelligent automation solutions tailored to your business processes.'
    },
    {
      icon: 'formation',
      title: 'AI Formation for Business',
      description: 'Empower your team with cutting-edge AI knowledge. Comprehensive training programs designed to help your organization leverage AI effectively and stay competitive.'
    },
    {
      icon: 'audit',
      title: 'Software Performance Audit',
      description: 'In-depth analysis of your software systems to identify bottlenecks, optimize performance, and ensure scalability. Get actionable insights to maximize efficiency.'
    }
  ],
  portfolio: [
    {
      client: 'STUDIO COO',
      industry: 'Market Research',
      description: 'Automated market research workflow that generates comprehensive reports by simply inputting a product name. Drastically reduced time and resources spent on market research with impressive accuracy and insights.',
      solution: 'AI-Powered Market Research Automation',
      result: 'Competitive edge',
      testimonial: 'We now have an automated market research workflow that generates comprehensive reports by simply inputting a product name. This has drastically reduced the time and resources we previously spent on market research, and the accuracy and insights are impressive, giving us a competitive edge, and we could not be more pleased with the results.',
      author: 'Head of Ops'
    },
    {
      client: 'Bex Care',
      industry: 'Assurtech',
      description: 'AI chatbot handles client inquiries instantly, improving response times and enhancing overall customer satisfaction while significantly reducing team workload.',
      solution: 'Intelligent Customer Service Chatbot',
      result: 'Instant response',
      testimonial: 'Our client service has reached a whole new level. The chatbot handles client inquiries instantly, improving response times and enhancing overall customer satisfaction. It has significantly reduced our team workload. Their technical expertise and understanding of our business needs were crucial in making this project a success.',
      author: 'Chief Sales Officer'
    },
    {
      client: 'Dr. Dieudonnée METO',
      industry: 'Healthcare Practice',
      description: 'Automated prescription generation during consultations allows doctors to focus more on patients and less on administrative tasks. Fast, efficient, and error-free system improving patient care.',
      solution: 'Healthcare Workflow Automation',
      result: 'Streamlined operations',
      testimonial: 'The automation of prescription generation during consultations has been a game-changer for my practice. They created a solution that allows me to focus more on my patients and less on administrative tasks. The automated system is fast, efficient, and error-free, making my workflow smoother and improving patient care. I highly recommend their services to any healthcare professional looking to streamline their operations.',
      author: 'Doctor Dieudonnée METO'
    },
    {
      client: 'POD SaaS',
      industry: 'SaaS & Technology',
      description: 'Scalable SaaS platform for online profiles and NFC tagging that allows users to easily create profiles and link them to NFC devices for seamless interactions.',
      solution: 'Custom SaaS Platform Development',
      result: 'Scalable, Customer Centric Platform',
      testimonial: 'Developing our SaaS platform for online profiles and NFC tagging has been an incredible experience. They delivered a scalable solution that allows users to easily create profiles and link them to NFC devices for seamless interactions. Problem-solving approach and attention to detail have made the platform intuitive and user-friendly, and our users are thrilled with the results.',
      author: 'POD Team'
    }
  ],
  benefits: [
    {
      title: 'Reduce Labor Costs',
      description: 'Automate repetitive tasks and free up your team to focus on high-value strategic work that drives growth.'
    },
    {
      title: 'Scale Without Hiring',
      description: 'Handle 10x more workload with AI-powered systems that work 24/7 without additional headcount.'
    },
    {
      title: 'Eliminate Human Error',
      description: 'AI systems ensure consistent accuracy in data processing, reducing costly mistakes and rework.'
    },
    {
      title: 'Faster Time to Market',
      description: 'Accelerate development cycles and launch products faster with optimized engineering processes.'
    },
    {
      title: 'Competitive Advantage',
      description: 'Stay ahead of competitors by leveraging cutting-edge AI technology before it becomes mainstream.'
    },
    {
      title: 'Data-Driven Insights',
      description: 'Make better business decisions with AI-powered analytics that reveal hidden patterns and opportunities.'
    }
  ]
};
